import { FaCalendarAlt, FaClock } from "react-icons/fa";

const DEFAULT_SLOTS = ["09:00", "10:00", "11:00", "12:00", "14:00", "15:00", "16:00", "17:00"];

export default function TimeSlotSelector({
  selectedDate,
  setSelectedDate,
  selectedTime,
  setSelectedTime,
  timeSlots = DEFAULT_SLOTS,
  slotsFromApi = [],
  selectedSlot,
  setSelectedSlot,
  minDate,
  maxDate,
}) {
  const slots = timeSlots?.length ? timeSlots : DEFAULT_SLOTS;
  const effectiveMinDate = minDate || new Date().toISOString().slice(0, 10);
  const useSlotBased = Array.isArray(slotsFromApi) && slotsFromApi.length > 0;

  const formatDisplayDate = (ymd) => {
    if (!ymd) return null;
    const d = new Date(ymd + "T12:00:00");
    return isNaN(d.getTime()) ? null : d.toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });
  };
  const hasBookableRange = effectiveMinDate || maxDate;
  const bookableText = hasBookableRange
    ? maxDate
      ? `${formatDisplayDate(effectiveMinDate) || "—"} to ${formatDisplayDate(maxDate) || "—"}`
      : effectiveMinDate
      ? `From ${formatDisplayDate(effectiveMinDate)}`
      : null
    : null;

  return (
    <div className="space-y-4">
      {bookableText && (
        <div className="mb-3 p-3 rounded-xl bg-amber-50 border border-amber-200">
          <p className="text-xs font-semibold text-amber-800 uppercase tracking-wide mb-0.5">Bookable dates</p>
          <p className="text-sm text-amber-900">{bookableText}</p>
          <p className="text-xs text-amber-700 mt-1">Pick a date within this range.</p>
        </div>
      )}
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1 flex items-center gap-2">
          <FaCalendarAlt className="text-[#1ABCE3]" /> Start date
        </label>
        <input
          type="date"
          value={selectedDate}
          min={effectiveMinDate}
          max={maxDate || undefined}
          onChange={(e) => setSelectedDate(e.target.value)}
          className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-[#1ABCE3]/50 focus:border-[#1ABCE3]"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1 flex items-center gap-2">
          <FaClock className="text-[#1ABCE3]" /> {useSlotBased ? "Time slot" : "Time"}
        </label>
        {useSlotBased ? (
          <div className="space-y-2">
            {slotsFromApi.map((slot) => {
              const remaining = Number(slot.remaining) ?? Math.max(0, (slot.capacity || 0) - (slot.bookedCount || 0));
              const isFull = remaining <= 0;
              const isSelected = selectedSlot?._id === slot._id;
              return (
                <button
                  type="button"
                  key={slot._id}
                  onClick={() => !isFull && setSelectedSlot?.(slot)}
                  disabled={isFull}
                  className={`w-full px-4 py-3 rounded-xl border text-left flex items-center justify-between ${
                    isFull
                      ? "border-gray-200 bg-gray-100 text-gray-400 cursor-not-allowed"
                      : isSelected
                      ? "border-[#1ABCE3] bg-[#1ABCE3]/10 text-gray-900"
                      : "border-gray-300 hover:border-[#1ABCE3] hover:bg-gray-50 text-gray-800"
                  }`}
                >
                  <span className="text-sm font-medium">
                    {slot.startTime} – {slot.endTime}
                    {slot.label ? ` · ${slot.label}` : ""}
                  </span>
                  <span className="text-xs">
                    {isFull ? "Full" : `${remaining} left`}
                  </span>
                </button>
              );
            })}
          </div>
        ) : (
          <select
            value={selectedTime}
            onChange={(e) => setSelectedTime(e.target.value)}
            className="w-full px-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-[#1ABCE3]/50 focus:border-[#1ABCE3]"
          >
            {slots.map((t) => (
              <option key={t} value={t}>{t}</option>
            ))}
          </select>
        )}
      </div>
    </div>
  );
}
